import * as types from './actionTypes';  
import offeringCommunicationApi from '../api/offeringCommunicationApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doOfferingCommunication(request) {

  return {
    type: types.DO_OFFERING_COMMUNICATION, 
    request
  };
}

export function doOfferingCommunicationRes(data) {  
  return {
    type: types.DO_OFFERING_COMMUNICATION_RES, 
    data
  };
}

export function getOfferingCommunication(request) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      offeringCommunicationApi.doOfferingCommunication(request).then(data => {
        dispatch(doOfferingCommunicationRes(data));
        dispatch(doOfferingCommunicationRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}

